export default {
  API_URL: 'https://api-v2.mougelato.com/api/',
  FRONTEND_API_URL: 'https://api-v2.mougelato.com/api/frontend/',
  STORAGE_URL: 'https://api-v2.mougelato.com',
  IMG_LAZY: 'https://api-v2.mougelato.com/image-lazy.png',
  IMG_EMPTY: 'https://api-v2.mougelato.com/image-empty.png',
  IMG_ERROR: 'https://api-v2.mougelato.com/image-error.png',
  INSTAGRAM_API_URL: 'https://graph.instagram.com/me/media',
  INSTAGRAM_TOKEN: 'IGQVJWZA3ZAndG91ekhmaDFId1dfT3Q5R3BpdHVXWXU5d0M2MkVCdEY0Wnl3eWVEUFJGbkpvRGVwTE40cEpYQTZAncVdDMDFHekpjOWxBTi1hWmR3TWFkSlI0YnJNLVQxeGt2VS1qWmhhOUxuZAFVtWnRpbQZDZD'
}